export { default } from './Loading';



// WEBPACK FOOTER //
// ./src/design-system/atoms/Loading/index.jsx